import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

import { AccountServerPipe, FixRateCurrencyConverterPipe } from '@personal-area/global/accounts/utils';
import { SharedTransactionModule, TransactionStatusModule } from '@personal-area/global/billing/feature';
import { MoneyPipe } from '@personal-area/global/billing/utils';
import { BonusBannerComponent } from '@personal-area/global/deposit-bonus';
import {
  CardWrapperModule,
  IconComponent,
  ServersIndicatorModule,
  SortModule,
  SubMenuModule,
} from '@personal-area/global/ui';

import { AccountNamePipe } from '../../pipes/account-name.pipe';
import { AccountTypePipe } from '../../pipes/account-type.pipe';
import { AccountTypeIndicatorComponent } from '../account-type-indicator/account-type-indicator.component';
import { AccountViewerOverviewModule } from '../account-viewer-overview/account-viewer-overview.module';
import { AccountViewerPerformanceModule } from '../account-viewer-performance/account-viewer-performance.module';
import { DemoFundsButtonModule } from '../demo-funds-button/demo-funds-button.module';
import { TradeButtonComponent } from '../trade-button/trade-button.component';
import { AccountViewerComponent } from './account-viewer.component';

@NgModule({
  declarations: [AccountViewerComponent],
  exports: [AccountViewerComponent],
  imports: [
    AccountTypePipe,
    AccountNamePipe,
    AccountServerPipe,
    AccountTypeIndicatorComponent,
    AccountViewerOverviewModule,
    AccountViewerPerformanceModule,
    CardWrapperModule,
    CommonModule,
    FixRateCurrencyConverterPipe,
    IconComponent,
    MatDividerModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule,
    ServersIndicatorModule,
    AccountServerPipe,
    AccountTypeIndicatorComponent,
    MoneyPipe,
    FixRateCurrencyConverterPipe,
    SharedTransactionModule,
    SubMenuModule,
    TranslateModule,
    IconComponent,
    AccountTypePipe,
    DemoFundsButtonModule,
    TransactionStatusModule,
    SortModule,
    TradeButtonComponent,
    SharedTransactionModule,
    BonusBannerComponent,
  ],
})
export class AccountViewerModule {}
